module.exports = __webpack_public_path__ + "src/assets/images/marketing-materials-bg.jpg?07fd794cd72540936e5d8f305ac531e8";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/marketing-materials-bg.jpg
// module id = 1022
// module chunks = 1